import { render } from "./AdministratorSubpage.vue?vue&type=template&id=6f0c1ce4&scoped=true"
import script from "./AdministratorSubpage.vue?vue&type=script&lang=js"
export * from "./AdministratorSubpage.vue?vue&type=script&lang=js"

import "./AdministratorSubpage.vue?vue&type=style&index=0&id=6f0c1ce4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0c1ce4"]])

export default __exports__